import { render, staticRenderFns } from "./orderFormPage.vue?vue&type=template&id=5c48c894&"
import script from "./orderFormPage.vue?vue&type=script&lang=js&"
export * from "./orderFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\008-QLK_FE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c48c894')) {
      api.createRecord('5c48c894', component.options)
    } else {
      api.reload('5c48c894', component.options)
    }
    module.hot.accept("./orderFormPage.vue?vue&type=template&id=5c48c894&", function () {
      api.rerender('5c48c894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderFormPage.vue"
export default component.exports